export const BENCHMARKING_NOTIFICATIONS = {
  ERROR_FETCHING: 'Error fetching benchmarking data',
  ERROR_SAVING_SETTINGS: 'Error saving benchmarking settings',
};
